import React, { useEffect, useState, useContext } from 'react';

import GenericFormModal from './shared/GenericFormModal';
import EditNumber from './shared/field_inputs/number/EditNumber';
import EditDate from './shared/field_inputs/date/EditDate';
import EditItemList from './shared/field_inputs/item_list/EditItemList';
import EditBoolean from './shared/field_inputs/boolean/EditBoolean';
import { DataContext } from '../../stores/crm-deal-store';

import { createGetSuggestionsFromApiUrl } from './shared/field_inputs/HelpMethods';

const WonModal = ({ handleUpdate, label, description, initialValues }) => {
    const [disable, setDisable] = useState(initialValues.pipelineStage.pipelineId === '00000001-0000-0000-0000-000000000000' && initialValues.pipelineStageId !== '00000007-0000-0000-0000-000000000000');
    const [disabledTooltipText, setDisabledTooltipText] = useState(disable ? 'Dealen måste ligga i "Admin INNAN won"' : null);
    const [showUnderOrg, setShowUnderOrg] = useState(false);
    const [isProject, setIsProject] = useState(false);

    const {
        store: { currentPipelineStageId, currentPipelineId },
    } = useContext(DataContext);

    const checkShowUnderOrg = (formValues) => {
        setShowUnderOrg(formValues.underConsultants.some(underConsultant => underConsultant.id === null))
    };

    const formComponents = [
        {
            propName: 'startDate',
            label: 'Startdatum',
            validate: (v) => (!v || !v.length ? 'Måste vara ett datum' : ''),
            component: <EditDate />,
        },
        {
            propName: 'endDate',
            label: 'Slutdatum',
            validate: (v) => (!v || !v.length ? 'Måste vara ett datum' : ''),
            component: <EditDate />,
        },
        {
            propName: 'project',
            label: 'Projekt',
            component: <EditBoolean setBool={setIsProject} />,
        },
        {
            propName: 'consultants',
            label: 'Considkonsulter',
            validate: (v, item) => ((v && v.length) || (item.underConsultants && item.underConsultants.length) || isProject ? '' : 'Välj konsulter.'),
            component: (
                <EditItemList
                    iconName='people'
                    isClearable
                    isCreationPermitted
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmPersonFront/getPersonSuggestions')}
                />
            ),
        },
        {
            propName: 'underConsultantOrganizations',
            label: 'UK-bolag',
            visible: showUnderOrg,
            validate: (v, item) => (showUnderOrg && !(v && v.length)  ? 'Det går inte att skapa underkonsult utan att först lägga till UK-bolag' : ''),
            component: (
                <EditItemList
                    iconName='organization'
                    isClearable
                    isCreationPermitted
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmOrganizationFront/getOrganizationSuggestions')}
                />
            ),
        },
        {
            propName: 'underConsultants',
            label: 'Underkonsulter',
            validate: (v, item) => ((v && v.length) || (item.consultants && item.consultants.length) || isProject ? '' : 'Eller välj underkonsulter.'),
            component: (
                <EditItemList
                    iconName='people'
                    isClearable
                    isCreationPermitted
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmPersonFront/getPersonSuggestions')}
                />
            ),
        },
        {
            propName: 'hourRate',
            label: 'Timpris (till kund)',
            validate: (v) => (v || isProject ? '' : 'Måste vara ett tal'),
            component: <EditNumber isCurrency />,
        },
    ];

    useEffect(() => {
        if (currentPipelineStageId !== '' && currentPipelineId !== '') {
            setDisable(currentPipelineId === '00000001-0000-0000-0000-000000000000' &&
            currentPipelineStageId !== '00000007-0000-0000-0000-000000000000');
            setDisabledTooltipText(disable ? 'Dealen måste ligga i "Admin INNAN won"' : null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPipelineStageId, currentPipelineId]);

    return (
        <GenericFormModal
            label={label}
            disabled={disable}
            disabledTooltipText={disabledTooltipText}
            description={description}
            formComponents={formComponents}
            defaultFormValues={initialValues}
            handleAdd={handleUpdate}
            callback={checkShowUnderOrg}
        />
    );
};

WonModal.defaultProps = {
    initialValues: {},
};

export default WonModal;
